var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "navbar flex flex-row align-center justify-between" },
    [
      _c("div", { staticClass: "title" }),
      _c("div", { staticClass: "right-menu flex flex-row align-center" }, [
        _c(
          "span",
          {
            staticClass:
              "option-icon cursor-pointer flex align-center justify-center",
            on: {
              click: function ($event) {
                return _vm.fullScreen()
              },
            },
          },
          [
            _c("img", {
              staticClass: "ai-icon",
              attrs: { src: require("@/assets/list/ai.png"), alt: "ai" },
            }),
          ]
        ),
        _c(
          "span",
          {
            staticClass:
              "option-icon cursor-pointer flex align-center justify-center",
            on: {
              click: function ($event) {
                return _vm.fullScreen()
              },
            },
          },
          [
            _c("img", {
              staticClass: "icon",
              attrs: {
                src: require("@/assets/list/fullScreen.png"),
                alt: "ai",
              },
            }),
          ]
        ),
        _c(
          "span",
          {
            staticClass:
              "option-icon cursor-pointer flex align-center justify-center",
            on: {
              click: function ($event) {
                return _vm.home()
              },
            },
          },
          [
            _c("img", {
              staticClass: "icon",
              attrs: { src: require("@/assets/list/home.png"), alt: "ai" },
            }),
          ]
        ),
        _c(
          "span",
          {
            staticClass:
              "option-icon cursor-pointer flex align-center justify-center",
            on: {
              click: function ($event) {
                return _vm.logout()
              },
            },
          },
          [
            _c("img", {
              staticClass: "icon",
              attrs: { src: require("@/assets/list/poweroff.png"), alt: "ai" },
            }),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }